import { useRef, useMemo } from 'react';

export default function useInstance(fn, deps) {
  const instanceRef = useRef(null);
  const fnRef = useRef(fn);
  
  fnRef.current = fn;
  
  const instance = useMemo(() => {
    return instanceRef.current || (instanceRef.current = fnRef.current());
  }, [...deps, fnRef, instanceRef]);

  instanceRef.current = instance ?? fn();

  return instanceRef.current;
};